import helpers from './helpers'
import CustomerService from '@/services/API/CustomerService'
import { objectIsEmpty } from '@/services/JSUtils'
import SlCustomerBranchOffice from '../../../models/Sale/SlCustomerBranchOffice'

const setCustomerData = ({ commit, rootGetters }, customerData) => {
    commit('SET_CUSTOMER_DATA', customerData)
    // const activeTransaction = rootGetters['TransactionModule/activeTransaction']
    // const dataStatus = helpers.validateData(customerData, activeTransaction)
    // commit('SET_DATA_STATUS', dataStatus)
}

const fetchCustomerData = async ({ dispatch }, id) => {
    console.log(id, 'id fetchCustomer actions')
    const customer = await CustomerService.findById(id)
    console.log(customer, 'customer')
    if (!objectIsEmpty(customer)) {
        dispatch('setCustomerData', customer)
        return true
    }
    return false
}

const submitNewCustomer = async function({}, slCustomer) {
    console.log(slCustomer, 'im here22')
    let response = await CustomerService.submitCustomer(slCustomer)
    console.log(
        '%cTesting response',
        'color: white; background-color: lightblue; padding: 2px 5px; border-radius: 2px'
    )
    console.log(response)

    return response
}

const setActiveOfficeID = ({ commit }, id) => {
    commit('SET_ACTIVE_OFFICE_ID', id)
}

const resetCostumerState = function({ commit }) {
    commit('RESET_STATE')
}

const setRutCustomer = function({ commit }, rut) {
    commit('SET_RUT', rut)
}

const setCoreBusinessCustomer = function({ commit }, id) {
    commit('SET_CORE_BUSINESS', id)
}

const setBranchOffices = ({ commit }, offices) =>
    commit('SET_BRANCH_OFFICES', offices)

const fetchCustomerBranchOffices = ({ dispatch }, customerId) => {
    new SlCustomerBranchOffice()
        .fetchByCustomerId(customerId)
        .then(r => dispatch('setBranchOffices', r.data))
        .catch(console.log)
}

const setSelectedOffice = ({ commit }, id) => commit('SET_SELECTED_OFFICE', id)
const setCustomerReadonly = ({ commit }, bool) =>
    commit('SET_CUSTOMER_READONLY', bool)

const setCustomerPaymentConditionId = ({ commit }, id) =>
    commit('SET_CUSTOMER_PAYMENT_CONDITION_ID', id)

export default {
    resetCostumerState,
    setCustomerData,
    fetchCustomerData,
    submitNewCustomer,
    setRutCustomer,
    setActiveOfficeID,
    setCoreBusinessCustomer,
    setBranchOffices,
    fetchCustomerBranchOffices,
    setSelectedOffice,
    setCustomerReadonly,
    setCustomerPaymentConditionId,
}
